export default {"src":"/uk/_next/static/media/profileIcon.7e35321c.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};